<template>
  <v-dialog v-model="active" width="400">
    <template v-for="(_, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="slotData">
      <slot :name="scopedSlotName" v-bind="slotData"></slot>
    </template>
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
      <slot :name="slotName"></slot>
    </template>
    <v-card>
      <v-card-title>Request Advisor Change</v-card-title>
      <v-card-text>
        <p>Please note that while you can request to change your advisor, you might be assigned a different advisor based on if the requested advisor is going on sabbatical, or to keep the department's advising duties balanced between professors, or based on a system developed by the department of your major.</p>
        <v-select v-model="advisor" :items="advisorOptions" label="Requested Advisor" outlined />
      </v-card-text>
      <v-card-actions>
        <v-btn :disabled="advisor === ''" @click="save()" text>Save</v-btn>
        <v-spacer />
        <v-btn text @click="active = false">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { ref, watch } from '@vue/composition-api'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    prevAdv: Array,
    major: {
      type: String,
      required: true
    }
  },
  setup (props, { root, emit }) {
    const settingServ = root.$feathers.service('student/reg-setting')

    const active = ref(false)

    const advisor = ref('')
    const advisorOptions = ref([])

    watch(() => props.major, async () => {
      if (props.major) {
        const { data } = await settingServ.find({ query: { form: 'program', category: 'advisor', major: props.major, $sort: { term: -1 }, $limit: 1 } })
        if (data.length === 0) {
          alert('There was an error loading the advisors for the selected major. Please contact the Records office for assistance.')
        } else {
          advisorOptions.value = data[0].options.filter(({ value }) => !props.prevAdv.find(({ value: v }) => value === v))
        }
      }
    })

    async function save () {
      emit('save', { prev: props.prevAdv[0].value, value: advisor.value })
      active.value = false
    }

    watch(() => props.value, () => {
      if (props.value && !active.value) {
        advisor.value = ''
        active.value = true
      }
    })
    watch(active, () => {
      if (!active.value) emit('input', false)
    })

    return {
      active,
      advisor,
      advisorOptions,
      save
    }
  }
}
</script>
